import { ReactNode } from "react";

import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import type { SxProps } from "@mui/material/styles";
import { type Variant } from "@mui/material/styles/createTypography";

import { type Patient } from "services/types/patients.type";
import { formatPhoneNumber } from "utils/common";

import CallPatientNumberButton from "./call-patient-number-button.component";

type CallPatientLinkContentProps = {
  phoneNumber?: string;
  label?: ReactNode;
  patient?: Partial<Patient>;
  variant?: Variant;
  redirect?: boolean;
  sx?: SxProps;
  containerSx?: SxProps;
};

export default function CallPatientLinkContent({
  patient,
  phoneNumber,
  label = null,
  variant = "body1",
  redirect,
  containerSx,
  sx
}: CallPatientLinkContentProps) {
  return (
    <Box sx={{ display: "inline-block", ...containerSx }}>
      <Stack direction="row" alignItems="center">
        {label}
        <Typography variant={variant as any} sx={sx}>
          {formatPhoneNumber(phoneNumber)}
        </Typography>
        <Box>
          <CallPatientNumberButton
            size="small"
            title={patient?.fullName}
            patient={patient}
            phoneNumber={phoneNumber}
            redirect={redirect}
            sx={{ mt: -0.5 }}
          />
        </Box>
      </Stack>
    </Box>
  );
}
